<div class="container mt-4">
  @if (!registerMode && !securitycodeMode && !forgotpasswordMode) {
    <div class="row justify-content-center mb-4">
      <div class="col-lg-10">
        <div class="hero text-center">
          <img src="assets/De-Partsmanagers3-Logo.png" alt="De Partsmanagers" class="hero-logo mb-3">
          <h1 class="hero-title">Welcome to <span class="notranslate">Data XL</span></h1>
          <p class="lead mb-0">Your Gateway to Original and OEM Products.</p>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-md-6 col-lg-5 mb-4">
        <div class="card home-card h-100">
          <div class="card-header"><i class="fa fa-user-plus mr-2"></i>Create new account</div>
          <div class="card-body d-flex flex-column">
            <p class="lead">New to Data XL?</p>
            <p>Sign up now to gain exclusive access to our platform.</p>
            <ul class="feature-list list-unstyled">
              <li><i class="fa fa-check text-primary mr-2"></i>Browse price lists and promotions</li>
              <li><i class="fa fa-check text-primary mr-2"></i>Search by product code, license plate or VIN</li>
              <li><i class="fa fa-check text-primary mr-2"></i>Order directly online</li>
            </ul>
            <div class="text-center mt-auto">
              <button (click)="registerToggle()" class="btn btn-outline-primary btn-lg px-5">Register</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-5 mb-4">
        <div class="card home-card h-100">
          <div class="card-header"><i class="fa fa-sign-in mr-2"></i>Login</div>
          <div class="card-body">
            <p class="lead">If you are already a customer:</p>
            <form #loginForm="ngForm" (ngSubmit)="templogin()" autocomplete="off">
              <div class="form-group">
                <label for="username">Email address</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-envelope"></i></span>
                  </div>
                  <input
                    name="username"
                    [(ngModel)]="model.username"
                    class="form-control"
                    type="text"
                    placeholder="Email address">
                </div>
              </div>
              <div class="form-group">
                <label for="password">Password</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-lock"></i></span>
                  </div>
                  <input
                    name="password"
                    [(ngModel)]="model.password"
                    class="form-control"
                    type="password"
                    placeholder="Password">
                </div>
              </div>
              @if (validationErrors.length > 0) {
                <div class="alert alert-danger py-2">
                  {{validationErrors}}
                </div>
              }
              <button class="btn btn-primary btn-block mt-4" type="submit">Login</button>
              <div class="text-center mt-3">
                <a routerLink='/forgotpassword'>Forgot Password</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center mt-2">
      <div class="col-lg-10">
        <p class="text-center text-muted text-uppercase small mb-2">Original parts for all leading brands</p>
        <div class="brand-strip">
          <span>Audi</span>
          <span>BMW</span>
          <span>Mercedes-Benz</span>
          <span>Volkswagen</span>
          <span>Volvo</span>
          <span>Ford</span>
          <span>Toyota</span>
          <span>Hyundai</span>
          <span>Kia</span>
          <span>Peugeot</span>
          <span>Renault</span>
          <span>Tesla</span>
        </div>
      </div>
    </div>
  }


  @if (registerMode) {
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-4">
          <app-register (cancelRegister)="cancelRegisterMode($event)"></app-register>
        </div>
      </div>
    </div>
  }

  @if (securitycodeMode) {
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-4">
          <app-securitycode [modelCreds]="model" (cancelSecuritycode)="cancelSecuritycodeMode($event)"></app-securitycode>
        </div>
      </div>
    </div>
  }

  @if (forgotpasswordMode) {
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-4">
          <app-forgot-password (cancelForgotpassword)="cancelForgotpasswordMode($event)"></app-forgot-password>
        </div>
      </div>
    </div>
  }


</div>
